<ng-container *ngIf="isBrowser">
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">Verpflegung ab</span>
        <ng-container *ngTemplateOutlet="boardTypeList?.length > 0 ? extern : all"></ng-container>
    </div>
</ng-container>


<ng-template #extern>
    <div class="tour-wrapper">
        <ng-container *ngFor="let item of sortArray(boardTypeList)| slice:0:slicenbr">
            @if(!partner()?.filters?.['hide' + item.code + 'filter']) {
            <button class="tour-item-wrapper-ext" (click)="selected(item)" matRipple>
                <mat-icon class="tour-item-icon ">{{selectedList.indexOf(item.code) >= 0 ? 'check_box' :
                    'check_box_outline_blank'}}</mat-icon>
                <div class="bestprc">
                    <span multilang class="tour-item-name-ext">{{item.name}}</span>
                    <span multilang class="bestprcit">{{'ab'}} {{item.bestPricePerPerson?.value + ' ' +
                        item.bestPricePerPerson?.currency}} p.P.</span>
                </div>
            </button>
            }
        </ng-container>
        <ng-container *ngIf="boardTypeList.length > 5">
            <ng-container *ngIf="(slicenbr < boardTypeList.length) else less">
                <button class="showallbtn" (click)="showMore(boardTypeList.length)" matRipple>
                    <span multilang>{{'alle'}} {{boardTypeList.length}} {{'anzeigen'}}</span>
                </button>
            </ng-container>
            <ng-template #less>
                <button class="showallbtn" (click)="showMore(5)" matRipple>
                    <span multilang>{{'weniger anzeigen'}}</span>
                </button>
            </ng-template>
        </ng-container>
    </div>
</ng-template>

<ng-template #all>
    @if(!partner()?.filters?.hideOVfilter) {
    <div class="tmp-section-body tmp-flexy">
        <button multilang class="tmp-f-btn" [class.tmp-f-btn-selected]="ohneVerpflegung"
            (click)="selectohneVerpflegung()" matRipple>{{'Ohne Verpflegung'}}</button>
    </div>
    }
    <div class="tmp-section-body tmp-flexy">
        @if(!partner()?.filters?.hideUFfilter) {
        <button multilang class="tmp-f-btn" [class.tmp-f-btn-selected]="frustuck" (click)="selectfrustuck()"
            matRipple>{{'Frühstück'}}</button>
        }
        @if(!partner()?.filters?.hideHPfilter) {
        <button multilang class="tmp-f-btn tmp-m-left" [class.tmp-f-btn-selected]="halbpension"
            (click)="selecthalbpension()" matRipple>{{'Halbpension'}}</button>
        }
    </div>
    <div class="tmp-section-body tmp-flexy">
        @if(!partner()?.filters?.hideVPfilter) {
        <button multilang class="tmp-f-btn" [class.tmp-f-btn-selected]="vollpension" (click)="selectvollpension()"
            matRipple>{{'Vollpension'}}</button>
        }
        @if(!partner()?.filters?.hideAIfilter) {
        <button multilang class="tmp-f-btn tmp-m-left" [class.tmp-f-btn-selected]="allinclusive"
            (click)="selectallinclusive()" matRipple>{{'All Inclusive'}}</button>
        }
    </div>
</ng-template>